// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/font-awesome.scss
// module id = 11
// module chunks = 2